import React from "react";
import { Badge, colors } from "../design/badge";
import { User } from "../models/User";

interface UserRoleBadgeProps {
  role: User["role"];
}

const UserRoleBadge: React.FC<UserRoleBadgeProps> = ({ role }) => {
  let color;
  let title;

  switch (role) {
    case "superadmin":
      color = "green";
      title = "Super Admin";
      break;
    case "admin":
      color = "blue";
      title = "Admin";
      break;
    case "user":
      color = "purple";
      title = "User";
      break;
    case "suspended":
      color = "red";
      title = "Suspended";
      break;
    default:
      color = "yellow"; // Signifies an alert or problem
      title = role;
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default UserRoleBadge;
